import {
  LOAD_CREATE_OPERATION_DATA,
  CREATE_OPERATION_DATA_LOADED,
  CREATE_OPERATION_DATA_ERROR,
  DELETE_OPERATION,
  DELETE_OPERATION_SUCCESS,
  QUOTE_OPERATION,
  QUOTE_OPERATION_SUCCESS,
  QUOTE_OPERATION_ERROR,
  UPDATE_QUOTE_OPERATION,
  UPDATE_VALUES_QUOTE_OPERATION,
  SAVE_OPERATION,
  SAVE_OPERATION_SUCCESS,
  SAVE_OPERATION_ERROR,
  UPDATE_PRICE_QUOTE_OPERATION,
  CLEAR_SAVE_OPERATION,
} from '../constants/create-operation';

export const LoadCreateOperationData = () => ({
  type: LOAD_CREATE_OPERATION_DATA,
});

export const CreateOperationDataLoaded = ({ filters, quoteOperations }) => ({
  type: CREATE_OPERATION_DATA_LOADED,
  filters,
  quoteOperations
});

export const CreateOperationDataError = () => ({
  type: CREATE_OPERATION_DATA_ERROR,
});

export const ClearSaveOperation = () => ({
  type: CLEAR_SAVE_OPERATION,
});

export const DeleteOperation = operation => ({
  type: DELETE_OPERATION,
  operation,
});

export const DeleteOperationSuccess = operation => ({
  type: DELETE_OPERATION_SUCCESS,
  operation,
});

export const UpdateValuesQuoteOperation = (comissionSlider, operationId) => ({
  type: UPDATE_VALUES_QUOTE_OPERATION,
  comissionSlider,
  operationId
})

export const QuoteOperation = operation => ({
  type: QUOTE_OPERATION,
  operation,
});

export const UpdateQuoteOperation = operation => ({
  type: UPDATE_QUOTE_OPERATION,
  operation,
});

export const QuoteOperationSuccess = operation => ({
  type: QUOTE_OPERATION_SUCCESS,
  operation,
});

export const QuoteOperationError = () => ({
  type: QUOTE_OPERATION_ERROR,
});

export const SaveOperation = (operation, comission) => ({
  type: SAVE_OPERATION,
  operation,
  comission,
});

export const SaveOperationSuccess = operation => ({
  type: SAVE_OPERATION_SUCCESS,
  operation,
});

export const SaveOperationError = operation => ({
  type: SAVE_OPERATION_ERROR,
  operation,
});

export const UpdatePriceOperation = operation => ({
  type: UPDATE_PRICE_QUOTE_OPERATION,
  operation,
});
